import { supabase } from '../lib/supabase'
import { LocalRepository } from './localRepository'
import type { Repository } from './repository'
import { SupabaseRepository } from './supabaseRepository'

/**
 * 환경변수가 있으면 Supabase, 없으면 로컬 시드.
 * 덕분에 백엔드 없이도 `npm run dev` 만으로 6개 화면이 전부 동작한다.
 */
export const repository: Repository = supabase
  ? new SupabaseRepository(supabase)
  : new LocalRepository()

export type { Repository } from './repository'
